import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
interface IConfirmModalContext {
  data: string;
  title?: string;
  confirmationText?: string;
  cancelText?: string;
}
@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss'],
})
export class LoginModalComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(DOCUMENT) private document,
    public modal: SuiModal<IConfirmModalContext, void, void>,
    private router: Router
  ) {}
  ngOnInit() {
    this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    this.document.body.classList.add('panel');
  }
  eServicesURL = '';
  onSubmit() {
    console.log(this.modal.context.data);
    let listItems = JSON.parse(localStorage.getItem('listItems') || '[]');
    let extractedItems = listItems.map((item) => ({
      lotId: item.lotId || '',
      biddingStageId: item.biddingStageId || '',
    }));
    extractedItems = extractedItems.filter(
      (item) => item.lotId !== '' || item.biddingStageId !== ''
    );
    extractedItems.push({
      lotId: this.modal.context.data['lotId'],
      biddingStageId: this.modal.context.data['biddingStageId'],
    });
    window.localStorage.setItem('loginObject', JSON.stringify(extractedItems));
  }
  onLogin() {
    this.onSubmit();
    this.router.navigate(['/home-page/sign-in'], {
      queryParams: { source: 'procurement' },
    });
    this.modal.approve();
  }
  onSignup() {
    this.onSubmit();
    this.router.navigate(['/home-page/sign-up/irr-step2']);
    this.modal.approve();
  }
}

export class LoginModal extends ComponentModalConfig<
  IConfirmModalContext,
  void,
  void
> {
  constructor(
    title: string,
    data: any,
    size: ModalSize = ModalSize.Small,
    confirmationText?: string,
    cancelText?: string
  ) {
    super(LoginModalComponent, {
      title,
      data,
      confirmationText,
      cancelText,
    });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
